import { cn as e } from "../../lib/utils.es.js";
import { Select as t, SelectContent as n, SelectItem as r, SelectTrigger as i, SelectValue as a } from "../ui/select.es.js";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
// libs/ui-lib/src/components/TimePicker/TimePicker.tsx
var c = Array.from({ length: 12 }, (e, t) => t + 1), l = Array.from({ length: 60 }, (e, t) => t), u = ["AM", "PM"];
function d({ value: d, onChange: f, disabled: p = !1, className: m, dataTestId: h = "time-picker" }) {
	let g = d ? d.getHours() % 12 == 0 ? 12 : d.getHours() % 12 : void 0, _ = d?.getMinutes(), v = d ? d.getHours() >= 12 ? "PM" : "AM" : void 0, y = (e, t, n) => {
		let r = d ? new Date(d) : /* @__PURE__ */ new Date();
		r.setHours(e % 12 + (n === "PM" ? 12 : 0), t, 0, 0), f?.(r);
	};
	return /* @__PURE__ */ s("div", {
		className: e("flex items-center gap-1", m),
		"data-testid": h,
		children: [
			/* @__PURE__ */ s(t, {
				disabled: p,
				value: g === void 0 ? void 0 : String(g),
				onValueChange: (e) => y(Number(e), _ ?? 0, v ?? "AM"),
				children: [/* @__PURE__ */ o(i, {
					"aria-label": "Hour",
					className: "h-8 gap-1 px-2",
					"data-testid": `${h}--hour`,
					children: /* @__PURE__ */ o(a, { placeholder: "--" })
				}), /* @__PURE__ */ o(n, {
					className: "min-w-16",
					children: c.map((e) => /* @__PURE__ */ o(r, {
						value: String(e),
						children: String(e).padStart(2, "0")
					}, e))
				})]
			}),
			/* @__PURE__ */ o("span", {
				className: "text-muted-foreground text-sm",
				children: ":"
			}),
			/* @__PURE__ */ s(t, {
				disabled: p,
				value: _ === void 0 ? void 0 : String(_),
				onValueChange: (e) => y(g ?? 12, Number(e), v ?? "AM"),
				children: [/* @__PURE__ */ o(i, {
					"aria-label": "Minute",
					className: "h-8 gap-1 px-2",
					"data-testid": `${h}--minute`,
					children: /* @__PURE__ */ o(a, { placeholder: "--" })
				}), /* @__PURE__ */ o(n, {
					className: "min-w-16",
					children: l.map((e) => /* @__PURE__ */ o(r, {
						value: String(e),
						children: String(e).padStart(2, "0")
					}, e))
				})]
			}),
			/* @__PURE__ */ s(t, {
				disabled: p,
				value: v,
				onValueChange: (e) => y(g ?? 12, _ ?? 0, e),
				children: [/* @__PURE__ */ o(i, {
					"aria-label": "AM or PM",
					className: "h-8 gap-1 px-2",
					"data-testid": `${h}--period`,
					children: /* @__PURE__ */ o(a, { placeholder: "--" })
				}), /* @__PURE__ */ o(n, {
					className: "min-w-16",
					children: u.map((e) => /* @__PURE__ */ o(r, {
						value: e,
						children: e
					}, e))
				})]
			})
		]
	});
}
export { d as TimePicker };
